import { api } from 'app/config/apiConfig';
import i18n from 'app/config/i18Config/i18n';
import { showNotification } from 'app/providers/NotificationsProvider';
import { appActions } from '../model/slice/appSlice';
import { FeatureFlags } from '../model/types';

export const getFeatureFlagsConfigApi = api.injectEndpoints({
  endpoints: (build) => ({
    getFeatureFlagsConfig: build.query<FeatureFlags, void>({
      query: () => ({
        url: '/feature-flags',
      }),
      onQueryStarted: async (_, { queryFulfilled, dispatch }) => {
        try {
          dispatch(appActions.startLoading());

          await queryFulfilled;
        } catch (error) {
          showNotification('error', i18n.t('Error', { ns: 'common' }), i18n.t('Error when receiving configs', { ns: 'common' }));
        } finally {
          dispatch(appActions.stopLoading());
        }
      },
    }),
  }),
});

export const { useGetFeatureFlagsConfigQuery } = getFeatureFlagsConfigApi;
